<template>
  <div class="container">
    <div class="box-scan">
      <img src="@/assets/login/logo.png" class="logo">
      <div class="box-qr">
        <qrcode-vue class="qr" :value="'http://www.giiloo.com/scanlogin?qrticket=' + ticket" size="200" level="L" v-if="ticket" />
        <div class="reflash" v-show="timeout" @click="reyGet">
          <img src="@/assets/login/reflash.png" />
        </div>
      </div>
      <div class="text">
        使用微信扫一扫登录
      </div>
    </div>
  </div>
</template>

<script>
  import QrcodeVue from 'qrcode.vue'
  import { apiQrticket, apiVerify } from '../../request/api'

  export default {
    components: {
      QrcodeVue,
    },
    name: 'Index',
    // props: {
    //   msg: String
    // },
    data() {
      return {
        // loading: false,
        ticket: null,
        getTicketTime: null,
        timeout: true,
      }
    },
    mounted() {
      this.init(

      )
    },
    methods: {
      init() {
        this.getQrticket()
      },
      reyGet() {
        // 重新获取验证码
        this.ticket = null
        this.getTicketTime = null
        this.getQrticket()
      },
      getQrticket() {
        let self = this
        apiQrticket().then(res => {
          self.timeout = false
          // console.log("1")
          // console.log(res.data)
          self.ticket = res.data
          self.getTicketTime = Date.now()
          // console.log(self.getTicketTime)
          self.verify()
        }).catch(err => {
          console.log(err)
        })
      },
      verify() {
        // 判断2分钟超时
        let now = Date.now()
        let n = now - this.getTicketTime
        console.log(n)
        // if (n >= 2000) {
          if (n >= 100000) {
          this.timeout = true
          return
        }
        // 
        let self = this
        apiVerify({
          ticket: self.ticket
        }).then(res => {
          // console.log("2")
          // console.log(res.data)
          let code = res.data.code
          let data = res.data.data
          if (code == 9000) {
            // 等待授权
            setTimeout(() => {
              self.verify()
            }, 1000);
          } else if (code == 0) {
            // 登录成功
            localStorage.setItem('token', data)
            self.go('mp/activity')
          } else {
            //9001和其他 失败
            self.timeout = true
          }
        }).catch(err => {
          console.log(err)
          self.timeout = true
        })
      },
      go(where) {
        this.$router.push('/' + where)
      }
    }
  }
</script>

<style scoped>
  .container {
    width: 100%;
    height: 100%;
    background-image: url('../../assets/login/bg.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .box-scan {
    width: 320px;
    /* height: 360px; */
    background: #FFFFFF;
    box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.28);
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 40px;
    padding-bottom: 40px;
  }

  .logo {
    width: 120px;
    height: auto;
    display: block;
    margin-bottom: 30px;
  }

  .box-qr {
    width: 200px;
    height: 200px;
    position: relative;
  }

  .qr {
    width: 200px;
  }

  .reflash {
    position: absolute;
    top: 0;
    left: 0;
    width: 200px;
    height: 200px;
    background-color: rgba(255, 255, 255, 0.95);
    z-index: 2;
    text-align: center;
    line-height: 200px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /* display: none; */
  }

  .reflash:hover img {
    transform: scale(1.2,1.2) rotate(360deg)

  }

  .reflash img {
    width: 40px;
    height: 40px;
    display: block;
    transition: all 0.3s ease;
  }

  .text {
    margin-top: 30px;
    font-size: 16px;
    color: #1E3633;
  }
</style>